// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wizard-body[data-v-6e221a10] {\n  min-height: 400px;\n  max-height: 60vh;\n  overflow-y: auto;\n}[dir] .wizard-body[data-v-6e221a10] {\n  padding: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
